/**
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// 咨询-资金管理
const myService = resolve =>
  require(['../../../views/personalCenter/myService'], resolve)

export default [
  // 资金管理
  {
    name: 'myservice',
    path: '/myservice',
    component: myService
  },
  {
    name: 'myServiceOnPingan',
    path: '/myServiceOnPingan',
    component: myService
  }
]



// WEBPACK FOOTER //
// ./src/router/page/personalCenter/myService.js